module.exports = __webpack_public_path__ + "static/media/temp_45.e1cfceb7.jpg";